module.exports = __webpack_public_path__ + "static/img/baoming.dfee2ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/baoming.png
// module id = vAw0
// module chunks = 0